/**
 * Frozen Counterparty Opinion for the public sample.
 * Produced by the deterministic pipeline (methodology v1.1, rubric v1.4)
 * from the golden_sound fixture on 20 Oct 2026.
 * Opinion No. 1001 sits in the reserved specimen band (1–4999) and is never
 * issued to a customer. Summit Precision Plc is a fixture, not a public filing.
 */
const SPECIMEN = {
  opinionNumber: 1001,
  opinionDate: '20 Oct 2026',
  company: 'Summit Precision Plc',
  basis: 'FY25 statements · Vendor / supplier · Supplier (you buy from them)',
  condition: 'Sound',
  conditionVerdict:
    'Summit Precision Plc generates 14.2% net margins and covers interest 9.5×; liquidity is 2.10; leverage is 0.45× debt-to-equity. No metric approaches a distress threshold.',
  statementLead: 'On the FY25 statements',
  position:
    'Continuity is intact. Obligations are not impaired on these figures. Next look, the next annual 10-K.',
  figureRows: [
    { label: 'Net margin', value: '14.2%', note: null, binds: false },
    { label: 'Interest cover', value: '9.5×', note: null, binds: false },
    { label: 'Liquidity', value: '2.10', note: null, binds: false },
    { label: 'Leverage', value: '0.45×', note: null, binds: false }
  ],
  opinionRows: [
    { text: 'Continuity is intact.' },
    { text: 'Obligations are not impaired on these figures.' },
    { text: 'Next look, the next annual 10-K.' }
  ],
  soWhat:
    'The filed figures do not require a change to the terms, volume, or prepayment already negotiated with Summit Precision Plc.',
  evidence: [
    'Net margin 14.2% (IS) — Supports holding current exposure on earnings contribution',
    'Operating cash flow / current liabilities 90% (Computed) — Supports working-capital headroom on operating-cash-flow cover of current liabilities',
    'Debt-to-equity 0.45 (Computed) — Supports holding current exposure under moderate leverage',
    'Receivables turnover 9.5 (~38 DSO) (Computed) — Supports working-capital headroom on timely collections'
  ],
  falsifier: {
    improving:
      'A comparable Altman Z (1968) above 4.95 on the next annual filing sustains Summit Precision Plc in Sound.',
    worsening:
      'A quarter with current ratio below 1.00 without a committed facility amendment moves Summit Precision Plc to Watch.'
  },
  procurement:
    'The financials do not require a change to the payment terms, volume, or prepayment already negotiated with Summit Precision Plc. No dual-source change from this screen. Re-screen on the next annual 10-K.',
  treasury: 'Hold credit limit and exposure ceiling; annual re-screen.',
  methodologyVersion: 'v1.1',
  rubricVersion: 'v1.4'
};

export default SPECIMEN;
